import { makeStyles } from "@material-ui/core/styles";

export const fullWidthStyles = makeStyles((theme) => ({
  userContentCard: {
    marginTop: theme.shape.padding,
  },
  quill: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    "& span": {
      color: theme.palette.text.primary,
    },
  },
  accordionPanel: {
    width: "100%",
    flexDirection: "column",
  },
  accordionTitle: {
    display: "flex",
    alignItems: "center",
    textTransform: "uppercase",
    fontFamily: '"Rubik", "Roboto", sans-serif',
    paddingLeft: 20,
  },
  accordionSummary: {
    "& div.MuiAccordionSummary-content": {
      justifyContent: "space-between",
      alignItems: "center",
    },
    "& div.MuiAccordionSummary-expandIcon": {
      order: -1,
    },
  },
  accordionTitleWrap: {
    display: "flex",
  },
  findingsDetailContainer: {
    padding: "0 15px",
  },
  infoListItem: {
    paddingLeft: 0,
    color: theme.palette.text.primary,
  },
  infoListIcons: {
    color: theme.palette.text.primary,
    minWidth: 35,
  },
  infoLinkWrap: {
    display: "flex",
    justifyContent: "flex-start",
    padding: "8px 24px 16px",
  },
  infoTitleWrap: {
    display: "flex",
    justifyContent: "space-between",
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
    fontWeight: 300,
    "& p": {
      margin: 0,
      fontSize: 10,
      color: theme.palette.text.secondary,
    },
  },
  tooltip: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  contentContainer: {
    width: "100%",
    display: "flex",
    padding: theme.shape.padding,
    justifyContent: "space-between",
  },
  innerContainer: {
    width: "50%",
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.shape.padding,
    fontSize: 16,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 400,
    paddingBottom: 5,
  },
  analaysisContainer: {
    width: "100%",
  },
  analysisTextContainer: {
    overflowWrap: "anywhere",
    color: theme.palette.text.primary,
    fontSize: 16,
  },
  matchedMeta: {
    margin: "10px 0",
  },
  matchedMetaText: {
    paddingLeft: 5,
  },
  divider: {
    marginTop: theme.shape.padding,
  },
  addNoteWrapper: {
    display: "flex",
    alignItems: "center",
  },
}));
